'use client';

import { useEffect, useState } from 'react';
import { SidebarProvider, SidebarInset } from '../ui/sidebar';
import { SiteHeader } from './site-header.js';
import { SiteSidebar } from './site-sidebar.js';
import { useNavigation } from '../../hooks/use-navigation.js';
import { Outlet } from 'react-router-dom';  // import Outlet
import illustrator from "../../assets//illustrator/illus-background-2.png"
import { useTheme } from '../themeProvider';
import CopilotLauncher from '../copilot/CopilotLauncher';
import { PermissionGate } from '../guards/ModuleRouteGuards';

import { useSessionRefresh } from '../../hooks/useSessionRefresh';
import { BRANCH_FILTER_CHANGED_EVENT, getListBranchScopeKey } from '../../utils/branchSession';

export function AppLayout() {
  const { dynamicNav } = useNavigation();
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  const [branchScopeKey, setBranchScopeKey] = useState(getListBranchScopeKey);
  useSessionRefresh();

  useEffect(() => {
    const onBranchChange = () => setBranchScopeKey(getListBranchScopeKey());
    window.addEventListener(BRANCH_FILTER_CHANGED_EVENT, onBranchChange);
    return () => window.removeEventListener(BRANCH_FILTER_CHANGED_EVENT, onBranchChange);
  }, []);

  return (
    <SidebarProvider>
      <SiteSidebar menuItems={dynamicNav} />
      <SidebarInset>
        <SiteHeader menuItems={dynamicNav} />
        <main
          className="flex flex-1 flex-col min-h-0 overflow-hidden p-2 md:p-3 lg:p-3 bg-cover bg-no-repeat"
          style={{
            backgroundImage: !isDark ? `url(${illustrator})` : "none",
            backgroundPosition: "top right",
          }}
        >
          <PermissionGate>
            <Outlet key={branchScopeKey} />
          </PermissionGate>
        </main>
        {/* App-wide AI Copilot. Hides itself on /ai/copilot so the full-page
            workspace isn't shadowed by the docked panel. */}
        <CopilotLauncher />
      </SidebarInset>
    </SidebarProvider>
  );
}